/**
 *
 * @namespace administration
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/Medication/administration.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

/**
 * @constant PILL
 * @memberof administration
 * @type {string}
 */
export const PILL = '46992007';

/**
 * @constant INJECTION
 * @memberof administration
 * @type {string}
 */
export const INJECTION = '385219001';
